import React from 'react';
import { Routes, Route } from 'react-router-dom';
import SignIn from './Components/Signinpage';
import SignUp from './Components/Signuppage';
import HomepageComponent from './Components/HomepageComponent';
import Dashboard from './Components/DashboardComponent';
import Properties from './Components/PropertiesComponent';
import PropertyForm from './Components/AddpropertyComponent';
import Profile from './Components/ProfileComponent';
import Paymentgateway from './Components/PaymentgatewayComponent';
import PaymentHistory from './Components/PaymentHistory';
import ForgotPassword from './Components/Forgetpassword';
import OrderHistory from './Components/OrdersComponent';
import ShopPayments from './Components/ShopPaymentsComponent';
const App = () => {
    return (
        <Routes>
            <Route path="/" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path='/forgetpassword' element={<ForgotPassword/>}/>
            <Route element={<HomepageComponent />}>
                <Route path="/home" element={<Dashboard />} />
                <Route path="/properties" element={<Properties />} />
                <Route path="/propertyform" element={<PropertyForm />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/paymentgateway" element={<Paymentgateway />} />
                <Route path='/paymenthistory' element={<PaymentHistory/>}/>
                <Route path='/orders' element={<OrderHistory/>}/>
                <Route path='/shoppayments' element={<ShopPayments/>}/>
            </Route>
        </Routes>
    );
};

export default App;
